import { FC, memo } from "react";

export interface StockHeaderProps {
  /** Page title - from AEM, can be null */
  title: string | null;
  /** Whether to show the disclaimer text */
  showDisclaimer: boolean;
  /** AEM-authored disclaimer text */
  disclaimerText?: string;
}

const StockHeader: FC<StockHeaderProps> = memo(({ title, showDisclaimer, disclaimerText }) => {
  if (!title) {
    return null;
  }

  return (
    <header className="px-[10px] md:px-0 my-[14px] md:my-0">
      <h1 className="box-border font-[Rubik] block m-0 h-[27.5px] w-full max-w-[868px] text-[18px] md:text-[20px] font-medium leading-normal pb-2 text-[rgb(26,26,26)]">
        {title}
      </h1>
      {showDisclaimer && (
        <p className="box-border block m-0 h-[14px] w-full max-w-[868px] text-[10px] md:text-xs leading-normal text-[rgb(102,102,102)] [unicode-bidi:isolate]">
          {disclaimerText ?? "Prices aren\u0027t real time"}
        </p>
      )}
    </header>
  );
});

StockHeader.displayName = "StockHeader";

export default StockHeader;
